import { Product, ProductType, FrameHeaderProduct} from '../';

export function IsFramHeaderProductForTextureId(product: Product, claddingTextureMaterialId: string | undefined): product is FrameHeaderProduct {
  return (product as FrameHeaderProduct).productType === ProductType.FRAME_HEADER &&
    (product as FrameHeaderProduct).textureMaterial.specification.forTextureMaterialId === claddingTextureMaterialId;
}
